import EmptyState, {
	type EmptyStateProps,
} from '@liquidweb-dev/undercurrent/EmptyState';
import UserKeyIcon from '@liquidweb-dev/undercurrent/icons/lucide/UserKey';
import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';

/** The empty state for content whose requests all returned 403 Forbidden. */
const ForbiddenState = ({ sx, children, ...rest }: EmptyStateProps) => (
	<EmptyState
		icon={
			<UserKeyIcon
				sx={{
					height: ({ size }) => size.md,
					width: ({ size }) => size.md,
					color: ({ vars }) => vars.palette.uc.highlight.icon.main,
				}}
			/>
		}
		sx={combineSx({ maxWidth: '264px' }, sx)}
		{...rest}
	>
		{children || 'You do not have permission to view this content.'}
	</EmptyState>
);

export default ForbiddenState;
